import React from 'react';
import { AppBar, Box, Toolbar, IconButton, ButtonProps } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

interface IProps {
  toggleDrawer: ButtonProps['onClick'];
}

const Header: React.FC<IProps> = ({ toggleDrawer }) => {
  return (
    <Box data-testid="admin-app-header" sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" color="inherit">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="primary"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
          <a href={`${process.env.PUBLIC_URL}/dashboard`}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logos/tp-logo-text-green.png`}
              alt="tp-logo"
              style={{ width: '120px' }}
            />
          </a>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
